import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'currency',
  standalone: true
})
export class CurrencyPipe implements PipeTransform {
  transform(value: any, precision: number = 2, currency: string | null = null): unknown {
    if (currency === null || currency.length !== 3) {
      currency = 'EUR';
    }

    let input = parseFloat(value);

    if (isNaN(input))
      return value;

    precision = precision || 2;

    return Intl.NumberFormat('fr-FR', {
      maximumFractionDigits: precision,
      minimumFractionDigits: precision,
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol'
    }).format(input);
  }
}
